import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Spacing from "@irati/ui/src/Spacing"
import {Body, H2} from "@irati/ui/src/Typography"
import FormattedMessage from "@irati/utils/lang"
import React from "react"
import {SETTINGS_CUSTOM_REWARDS_CREATE} from "../../../routes/routeConfig"
import CustomRewardsList from "./CustomRewardsList"
const CustomRewards = () => {
  return (
    <Flex direction="column" gap={1}>
      <H2>
        <FormattedMessage id="admin.customRewards.home.heading" />
      </H2>
      <Body small>
        <FormattedMessage id="admin.customRewards.home.body" />
      </Body>
      <Flex marginTop={1} gap={2}>
        <ButtonRouterLink primary to={`${SETTINGS_CUSTOM_REWARDS_CREATE}`}>
          <FormattedMessage id="admin.customRewards.home.cta" />
        </ButtonRouterLink>
        <Button>
          <FormattedMessage id="platform.ui.banner.cta.text" />
        </Button>
      </Flex>
      <Spacing marginTop={4}>
        <CustomRewardsList />
      </Spacing>
    </Flex>
  )
}

export default CustomRewards
